import { TFCartContent } from '~graphql/generated/clientGraphql'

/**
 * Returns a hashed string that should uniquely identify items with a certain product, addons etc. in the order.
 * Useful for grouping of those item in a Cart.
 */
export const getOrderItemHash = (item: TFCartContent['items'][number]) => {
  const addonIds = item.addons
    .map((addon) => addon.product.id)
    .sort()
    .join('#')

  return `${item.product.id}#${addonIds}#${item.price.value}#${item.note}#${item.addedAutomatically}`
}
